/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as IndexRouteImport } from './routes/index'
import { Route as SeedsIndexRouteImport } from './routes/seeds/index'
import { Route as SeedsInstallationRouteImport } from './routes/seeds/installation'
import { Route as SeedsAcceleratedAgingIdRouteImport } from './routes/seeds/accelerated-aging.$id'
import { Route as SeedsGerminationIdRouteImport } from './routes/seeds/germination.$id'
import { Route as SeedsSandBedIdRouteImport } from './routes/seeds/sand-bed.$id'
import { Route as SeedsTetrazoliumIdRouteImport } from './routes/seeds/tetrazolium.$id'

const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)
const SeedsIndexRoute = SeedsIndexRouteImport.update({
  id: '/seeds/',
  path: '/seeds/',
  getParentRoute: () => rootRouteImport,
} as any)
const SeedsInstallationRoute = SeedsInstallationRouteImport.update({
  id: '/seeds/installation',
  path: '/seeds/installation',
  getParentRoute: () => rootRouteImport,
} as any)
const SeedsAcceleratedAgingIdRoute = SeedsAcceleratedAgingIdRouteImport.update({
  id: '/seeds/accelerated-aging/$id',
  path: '/seeds/accelerated-aging/$id',
  getParentRoute: () => rootRouteImport,
} as any)
const SeedsGerminationIdRoute = SeedsGerminationIdRouteImport.update({
  id: '/seeds/germination/$id',
  path: '/seeds/germination/$id',
  getParentRoute: () => rootRouteImport,
} as any)
const SeedsSandBedIdRoute = SeedsSandBedIdRouteImport.update({
  id: '/seeds/sand-bed/$id',
  path: '/seeds/sand-bed/$id',
  getParentRoute: () => rootRouteImport,
} as any)
const SeedsTetrazoliumIdRoute = SeedsTetrazoliumIdRouteImport.update({
  id: '/seeds/tetrazolium/$id',
  path: '/seeds/tetrazolium/$id',
  getParentRoute: () => rootRouteImport,
} as any)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/seeds/installation': typeof SeedsInstallationRoute
  '/seeds/': typeof SeedsIndexRoute
  '/seeds/accelerated-aging/$id': typeof SeedsAcceleratedAgingIdRoute
  '/seeds/germination/$id': typeof SeedsGerminationIdRoute
  '/seeds/sand-bed/$id': typeof SeedsSandBedIdRoute
  '/seeds/tetrazolium/$id': typeof SeedsTetrazoliumIdRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/seeds/installation': typeof SeedsInstallationRoute
  '/seeds': typeof SeedsIndexRoute
  '/seeds/accelerated-aging/$id': typeof SeedsAcceleratedAgingIdRoute
  '/seeds/germination/$id': typeof SeedsGerminationIdRoute
  '/seeds/sand-bed/$id': typeof SeedsSandBedIdRoute
  '/seeds/tetrazolium/$id': typeof SeedsTetrazoliumIdRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/seeds/installation': typeof SeedsInstallationRoute
  '/seeds/': typeof SeedsIndexRoute
  '/seeds/accelerated-aging/$id': typeof SeedsAcceleratedAgingIdRoute
  '/seeds/germination/$id': typeof SeedsGerminationIdRoute
  '/seeds/sand-bed/$id': typeof SeedsSandBedIdRoute
  '/seeds/tetrazolium/$id': typeof SeedsTetrazoliumIdRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/seeds/installation'
    | '/seeds/'
    | '/seeds/accelerated-aging/$id'
    | '/seeds/germination/$id'
    | '/seeds/sand-bed/$id'
    | '/seeds/tetrazolium/$id'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/seeds/installation'
    | '/seeds'
    | '/seeds/accelerated-aging/$id'
    | '/seeds/germination/$id'
    | '/seeds/sand-bed/$id'
    | '/seeds/tetrazolium/$id'
  id:
    | '__root__'
    | '/'
    | '/seeds/installation'
    | '/seeds/'
    | '/seeds/accelerated-aging/$id'
    | '/seeds/germination/$id'
    | '/seeds/sand-bed/$id'
    | '/seeds/tetrazolium/$id'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  SeedsInstallationRoute: typeof SeedsInstallationRoute
  SeedsIndexRoute: typeof SeedsIndexRoute
  SeedsAcceleratedAgingIdRoute: typeof SeedsAcceleratedAgingIdRoute
  SeedsGerminationIdRoute: typeof SeedsGerminationIdRoute
  SeedsSandBedIdRoute: typeof SeedsSandBedIdRoute
  SeedsTetrazoliumIdRoute: typeof SeedsTetrazoliumIdRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/seeds/': {
      id: '/seeds/'
      path: '/seeds'
      fullPath: '/seeds/'
      preLoaderRoute: typeof SeedsIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/seeds/installation': {
      id: '/seeds/installation'
      path: '/seeds/installation'
      fullPath: '/seeds/installation'
      preLoaderRoute: typeof SeedsInstallationRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/seeds/accelerated-aging/$id': {
      id: '/seeds/accelerated-aging/$id'
      path: '/seeds/accelerated-aging/$id'
      fullPath: '/seeds/accelerated-aging/$id'
      preLoaderRoute: typeof SeedsAcceleratedAgingIdRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/seeds/germination/$id': {
      id: '/seeds/germination/$id'
      path: '/seeds/germination/$id'
      fullPath: '/seeds/germination/$id'
      preLoaderRoute: typeof SeedsGerminationIdRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/seeds/sand-bed/$id': {
      id: '/seeds/sand-bed/$id'
      path: '/seeds/sand-bed/$id'
      fullPath: '/seeds/sand-bed/$id'
      preLoaderRoute: typeof SeedsSandBedIdRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/seeds/tetrazolium/$id': {
      id: '/seeds/tetrazolium/$id'
      path: '/seeds/tetrazolium/$id'
      fullPath: '/seeds/tetrazolium/$id'
      preLoaderRoute: typeof SeedsTetrazoliumIdRouteImport
      parentRoute: typeof rootRouteImport
    }
  }
}

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  SeedsInstallationRoute: SeedsInstallationRoute,
  SeedsIndexRoute: SeedsIndexRoute,
  SeedsAcceleratedAgingIdRoute: SeedsAcceleratedAgingIdRoute,
  SeedsGerminationIdRoute: SeedsGerminationIdRoute,
  SeedsSandBedIdRoute: SeedsSandBedIdRoute,
  SeedsTetrazoliumIdRoute: SeedsTetrazoliumIdRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
